import { faHeadset, faLaptopFile, faUserTie } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import FASvgIcon from "../../components/FASvgIcon";
import {
	ForgotPasswordForm,
	LoginForm,
	RegisterForm,
	ResetPasswordForm,
	VerificationForm
} from "../../components/auth";
import RegistrationSuccessfull from "../../components/auth/RegistrationSuccessfull";
import { appConstants } from "../../config/app-constants";

const AuthContainer: React.FC = () => {
	const { pathname } = useLocation();

	return (
		<div className="auth-page-wrap">
			<Container fluid>
				<Row className="h-100">
					<Col md="auto" className="col-left-wrap">
						<div className="overlay d-flex flex-column align-items-start justify-content-between">
							<div className="brand-logo-wrap">
								<img
									src={`${appConstants.basePath}/assets/images/logo.svg`}
									className="img-fluid"
									alt="logo"
								/>
							</div>
							<div className="feature-wrap">
								<h2 className="fw-bold mb-5 text-primary">
									Choose <span className="text-white">your Path</span>
								</h2>
								<p className="leading-para text-white">
									<FASvgIcon icon={faLaptopFile} />
									<span>
										<strong className="d-block mb-2">DIY/Self ITR Filing</strong>
										The feature allows you to file the ITR by yourself with our intuitive guide.
									</span>
								</p>
								<p className="leading-para text-white">
									<FASvgIcon icon={faHeadset} />
									<span>
										<strong className="d-block mb-2">Assisted ITR Filing</strong>
										Let our experts handle the filing.
									</span>
								</p>
								<p className="leading-para text-white">
									<FASvgIcon icon={faUserTie} />
									<span>
										<strong className="d-block mb-2">SaaS for Professionals</strong>
										Use our SaaS for effortless filing.
									</span>
								</p>
							</div>
							<div className="copyright-wrap text-white">Copyrights {new Date().getFullYear()}</div>
						</div>
					</Col>
					<Col className="col-right-wrap">
						<div className="brand-logo-wrap">
							<img
								src={`${appConstants.basePath}/assets/images/logo-dark.svg`}
								className="img-fluid"
								alt="logo"
							/>
						</div>
						<>
							{pathname === "/login" && <LoginForm />}
							{pathname === "/register" && <RegisterForm />}
							{pathname === "/verification" && <VerificationForm />}
							{pathname === "/register-success" && <RegistrationSuccessfull />}
							{pathname === "/reset-password" && <ResetPasswordForm />}
							{pathname === "/forgot-password" && <ForgotPasswordForm />}
						</>
						<div className="copyright-wrap text-center text-greyMedium d-block d-md-none">
							Copyrights {new Date().getFullYear()}
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
};

export default AuthContainer;
